
export const parseFilterKeys = (indexes)=>{
    return {
        years: Object.keys(indexes.years),
        states: Object.keys(indexes.states),
        subjects: Object.keys(indexes.subjects),
        value:{ year:"", state:"", subject:""}
    }
}
export const booksListParser = (books)=> {
    let initObj = {
        indexes:{
            ids:[],
            states:[],
            years:[],
            catergories:[],
            subjects:[]
        }
    };
    let data = books.reduce((obj, el, index) =>{
        if(el.bookmeta) {
            const bookId = el.id;
            obj[bookId] = el;
            let otherISBN = el.bookmeta.studentDigitalISBN 
            if(otherISBN && typeof otherISBN !== "string") {
                otherISBN.join(",")
            }
            obj[bookId].allISBNs = [el.isbn, el.bookmeta.physicalBookISBN, otherISBN, el.bookmeta.teacherDigitalISBN].join(","); 
            obj.indexes.ids.push(bookId);
            indexMetaProp({obj,el, prop:"division", indexKey:"catergories"});
            if(el.bookmeta.division && el.bookmeta.division.toLowerCase() === "secondary") {
                indexMetaProp({obj,el, prop:"subject", indexKey:"subjects"});
                indexMetaProp({obj,el, prop:"state", indexKey:"states"});
                indexMetaProp({obj,el, prop:"yearLevel", indexKey:"years"});
            }
        }
        return obj
    }, initObj)
    return data;
}

const indexMetaProp = ({obj, el, prop, indexKey})=>{
    if(el.bookmeta.hasOwnProperty(prop)) {
        //TODO:to remove follwoing condition
        if(typeof el.bookmeta[prop] != "string") {
            el.bookmeta[prop] = el.bookmeta[prop].join(",");
        }
        el.bookmeta[prop] = el.bookmeta[prop].toLowerCase();
        const bookId = el.id;
        
        const value = el.bookmeta[prop].split(",");
        const index = obj.indexes[indexKey];
        console.log(value, el.bookmeta[prop]);

        value.forEach(item => {
            if(index[item]){
                index[item].push(bookId)
            } else {
                index[item] = [bookId]
            }
        });
    }
}
